import React from 'react';
import { motion } from 'framer-motion';
import { Play, Eye, Calendar } from 'lucide-react';
const featuredVideos = [{
  id: 'dQw4w9WgXcQ',
  title: 'The Path to Inner Stillness',
  description: 'Discover the ancient techniques for achieving deep meditation and mental clarity.',
  views: '45K',
  date: '2 weeks ago'
}, {
  id: 'dQw4w9WgXcQ',
  title: 'Awakening Your Spiritual Energy',
  description: 'Learn how to activate and balance your chakras through guided meditation.',
  views: '32K',
  date: '1 month ago'
}, {
  id: 'dQw4w9WgXcQ',
  title: 'Living in the Present Moment',
  description: 'Practical wisdom on mindfulness and staying grounded in daily life.',
  views: '58K',
  date: '3 weeks ago'
}];
export function SatguruSandesh() {
  return <section id="satguru" className="py-24 bg-white" data-id="element-222">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-223">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-224">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-225">
            <span className="text-[#8B9D83] font-medium tracking-widest uppercase text-sm mb-2 block" data-id="element-226">
              Satguru Sandesh
            </span>
            <h2 className="font-serif text-4xl md:text-5xl text-[#2C3E50] mb-6" data-id="element-227">
              Wisdom from the Master
            </h2>
            <p className="text-lg text-[#5D6D7E] max-w-2xl mx-auto" data-id="element-228">
              Watch enlightening discourses and guided meditations to deepen
              your spiritual practice
            </p>
          </motion.div>
        </div>

        {/* Video Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-229">
          {featuredVideos.map((video, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="group bg-[#FAF7F2] rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer" data-id="element-230">
              {/* Video Thumbnail */}
              <div className="relative aspect-video bg-gray-200 overflow-hidden" data-id="element-231">
                <img src={`https://img.youtube.com/vi/${video.id}/maxresdefault.jpg`} alt={video.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-232" />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center" data-id="element-233">
                  <div className="w-16 h-16 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center transform group-hover:scale-110 transition-transform shadow-lg" data-id="element-234">
                    <Play className="w-7 h-7 text-[#8B9D83] fill-current ml-1" data-id="element-235" />
                  </div>
                </div>
              </div>

              {/* Video Info */}
              <div className="p-6" data-id="element-236">
                <h3 className="font-serif text-xl font-bold text-[#2C3E50] mb-3 group-hover:text-[#8B9D83] transition-colors" data-id="element-237">
                  {video.title}
                </h3>
                <p className="text-[#5D6D7E] text-sm mb-4 leading-relaxed" data-id="element-238">
                  {video.description}
                </p>
                <div className="flex items-center gap-4 text-xs text-[#5D6D7E]" data-id="element-239">
                  <div className="flex items-center gap-1" data-id="element-240">
                    <Eye className="w-4 h-4" data-id="element-241" />
                    <span data-id="element-242">{video.views} views</span>
                  </div>
                  <div className="flex items-center gap-1" data-id="element-243">
                    <Calendar className="w-4 h-4" data-id="element-244" />
                    <span data-id="element-245">{video.date}</span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* More Videos Button */}
        <div className="text-center mb-24" data-id="element-246">
          <motion.button initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="inline-flex items-center justify-center px-8 py-3 border-2 border-[#8B9D83] text-[#8B9D83] hover:bg-[#8B9D83] hover:text-white rounded-full font-medium transition-all duration-300 group" data-id="element-247">
            More Videos
            <Play className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" data-id="element-248" />
          </motion.button>
        </div>

        {/* Full-Width Meditation Center Video */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative" data-id="element-249">
          <div className="text-center mb-8" data-id="element-250">
            <h3 className="font-serif text-3xl md:text-4xl text-[#2C3E50] mb-4" data-id="element-251">
              Experience Our Sacred Space
            </h3>
            <p className="text-[#5D6D7E] max-w-2xl mx-auto" data-id="element-252">
              Take a virtual tour of Supradhyan Enlightenment Center and immerse
              yourself in the tranquil atmosphere
            </p>
          </div>

          <div className="relative aspect-video rounded-2xl overflow-hidden shadow-2xl bg-gray-200" data-id="element-253">
            {/* Video Placeholder - Replace with actual video embed */}
            <img src="https://images.unsplash.com/photo-1506126613408-eca07ce68773?q=80&w=2070&auto=format&fit=crop" alt="Meditation Center Tour" className="w-full h-full object-cover" data-id="element-254" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent flex items-center justify-center" data-id="element-255">
              <button className="w-20 h-20 rounded-full bg-white/95 backdrop-blur-sm flex items-center justify-center transform hover:scale-110 transition-transform shadow-2xl group" data-id="element-256">
                <Play className="w-9 h-9 text-[#8B9D83] fill-current ml-1 group-hover:text-[#7A8C72] transition-colors" data-id="element-257" />
              </button>
            </div>

            {/* Decorative corner accents */}
            <div className="absolute top-4 left-4 w-12 h-12 border-t-2 border-l-2 border-[#D4AF37]/50 rounded-tl-lg" data-id="element-258" />
            <div className="absolute top-4 right-4 w-12 h-12 border-t-2 border-r-2 border-[#D4AF37]/50 rounded-tr-lg" data-id="element-259" />
            <div className="absolute bottom-4 left-4 w-12 h-12 border-b-2 border-l-2 border-[#D4AF37]/50 rounded-bl-lg" data-id="element-260" />
            <div className="absolute bottom-4 right-4 w-12 h-12 border-b-2 border-r-2 border-[#D4AF37]/50 rounded-br-lg" data-id="element-261" />
          </div>
        </motion.div>
      </div>
    </section>;
}